import { dynamicImage } from "../../../Service/DynamicImage";

//Basic timeline
export const BASIC_TIMELINE = [
  {
    text: "Use the ",
    code: ".main-basic-timeline ",
  },
  {
    text: "class through made basic timeline.",
  },
];

export const BASIC_TIMELINE_LIST = [
  {
    color: "secondary",
    date: "22 March 2023",
    time: "3:45 PM",
    title: "DISCUSSION WITH MARKETING TEAM",
    span: "discussion with the marketing staff on the success of the most recent project",
  },
  {
    color: "success",
    date: "16 May 2023",
    time: "1:22 AM",
    title: "INVEST IN A NEW HOSTING PLAN",
    span: "today at 2 pm AM, purchase a new hosting package as agreed upon with the management team.",
  },
  {
    color: "warning",
    date: "23 Nov 2023",
    time: "6:56 AM",
    title: "DISCUSSION WITH DESIGNER TEAM",
    span: "",
  },
  {
    color: "info",
    date: "12 Dec 2023",
    time: "12:05 AM",
    title: "DISCUSSION WITH NEW THEME LAUNCH ",
    span: "discussion with the how many themes made in our portfolio.",
  },
  {
    color: "danger",
    date: "02 Jan 2024",
    time: "6:56 AM",
    title: "PURCHASE NEW CHAIRS FOR OFFICE ",
    span: "online purchase new chairs for office ",
  },
];

//Hovering Timelines
export const HOVERING_TIMELINE = [
  {
    text: "Use the ",
    code: ".square-timeline",
  },
  {
    text: " main class through create new variations of timeline.",
  },
];

//Variation Timelines
export const VARIATION_TIMELINE = [
  {
    text: "Use the ",
    code: ".activity-dot-primary ",
  },
  {
    text: "through rounded animations.",
  },
];

export const MEETUP_HOVERING = [
  {
    image: dynamicImage("avtar/4.jpg"),
    name: "Lillian J. Goodfellow",
    number: "239-664-7751",
  },
  {
    image: dynamicImage("avtar/7.jpg"),
    name: "Carolyn A. Sutton",
    number: "218-793-6609",
  },
];

export const VARIATION_TIMELINE_DATA = [
  {
    color: "warning",
    date: "5th Feb, 2023",
    time: "Today",
    title: "Added Bew Items",
    subTitle: "Quisque a consequat ante sit amet magna...",
    subTitleClass: "f-light",
    image: [dynamicImage("dashboard-2/product/1.png"), dynamicImage("dashboard-2/product/2.png"), dynamicImage("dashboard-2/product/3.png")],
  },
  {
    className: "pb-0",
    color: "secondary",
    date: "20th Sep, 2022",
    time: "12:00 PM",
    title: "Tello just like your product",
    subTitle: "Quisque a consequat ante sit amet magna...",
  },
];

//Horizontal Timelines
export const HORIZONTAL_TIMELINE = [
  {
    text: "Use the ",
    code: "square-timeline",
  },
  {
    text: " main class through create new variations of timeline.",
  },
];

export const HORIZONTAL_TIMELINE_DATA = [
  {
    mainClass: "timeline-border",
    child: [
      {
        colClass: "col-sm-6",
        color: "primary",
        date: "1 Jan",
        header: "Conference",
        paragraph: "Conferences are intended to bring individuals with similar interests together to discuss problems.",
        verticalLine1: "vertical-line",
      },
      {
        colClass: "col-sm-6",
        color: "success",
        date: "4 Feb",
        header: "Meet-up",
        paragraph: "You may connect with males from all around the world using the friend-forward.",
        verticalLine1: "vertical-line",
      },
      {
        colClass: "horizontal-timeline",
        color: "danger",
        date: "22 March",
        header: "Meeting",
        paragraph: "If several languages coalesce the grammar of the resulting simple and regular social networking platform.",
        verticalLine1: "vertical-line",
      },
    ],
  },
  {
    mainClass: "border-0",
    child: [
      {
        colClass: "col-sm-6",
        verticalLine2: "vertical-line",
        color: "primary",
        date: "1 Jan",
        header: "Conference",
        paragraph: "A gathering of two or more people to talk about issues of interest.",
      },
      {
        colClass: "col-sm-6",
        verticalLine2: "vertical-line",
        color: "danger",
        date: "22 March",
        header: "Meeting",
        paragraph: "If several languages coalesce the grammar of the resulting simple and regular social networking platform.",
      },
      {
        colClass: "horizontal-timeline",
        verticalLine2: "vertical-line",
        color: "warning",
        date: "7 Dec",
        header: "Launch Theme",
        paragraph: "Responsive Website is the approach that suggests website design and development should respond.",
      },
    ],
  },
];

//Timeline
export const TIMELINE = [
  {
    text: "This is a Boho timeline chart.",
  },
];

export const CAROUSEL_TIMELINE = [dynamicImage(`banner/2.jpg`), dynamicImage(`banner/1.jpg`), dynamicImage(`banner/3.jpg`)];
